(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SocialInsuranceDialogController', SocialInsuranceDialogController);

    SocialInsuranceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SocialInsurance'];

    function SocialInsuranceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SocialInsurance) {
        var vm = this;
        vm.socialInsurance = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:socialInsuranceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.socialInsurance.id !== null) {
                SocialInsurance.update(vm.socialInsurance, onSaveSuccess, onSaveError);
            } else {
                SocialInsurance.save(vm.socialInsurance, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
